module.exports = __webpack_public_path__ + "img/43.d221f465.svg";